import { Controller } from "@hotwired/stimulus"

// Universal mobile menu controller for both header and JAP navigation
export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon", "overlay", "hamburger"]

  connect() {
    console.log("Mobile menu controller connected")
    this.menuOpen = false
  }

  toggle() {
    console.log("Toggle called")

    // Support both types of menus
    if (this.hasMenuTarget) {
      const isHidden = this.menuTarget.classList.contains("hidden") ||
                       this.menuTarget.classList.contains("-translate-x-full")

      if (isHidden) {
        this.open()
      } else {
        this.close()
      }
    }
  }

  open() {
    console.log("Opening menu")
    this.menuOpen = true

    if (this.hasMenuTarget) {
      // For header menu (uses hidden class)
      this.menuTarget.classList.remove("hidden")

      // For JAP menu (uses transform)
      this.menuTarget.classList.remove("-translate-x-full")
      this.menuTarget.classList.add("translate-x-0")
    }

    // Handle icons
    if (this.hasOpenIconTarget) {
      this.openIconTarget.classList.add("hidden")
    }
    if (this.hasCloseIconTarget) {
      this.closeIconTarget.classList.remove("hidden")
    }
    if (this.hasHamburgerTarget) {
      this.hamburgerTarget.classList.add("hidden")
    }

    // Handle overlay for JAP menu
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("opacity-0", "pointer-events-none")
      this.overlayTarget.classList.add("opacity-100")
    }

    // Prevent body scroll when menu is open
    document.body.style.overflow = "hidden"
  }

  close() {
    console.log("Closing menu")
    this.menuOpen = false

    if (this.hasMenuTarget) {
      // For header menu (uses hidden class)
      this.menuTarget.classList.add("hidden")

      // For JAP menu (uses transform)
      this.menuTarget.classList.remove("translate-x-0")
      this.menuTarget.classList.add("-translate-x-full")
    }

    // Handle icons
    if (this.hasOpenIconTarget) {
      this.openIconTarget.classList.remove("hidden")
    }
    if (this.hasCloseIconTarget) {
      this.closeIconTarget.classList.add("hidden")
    }
    if (this.hasHamburgerTarget) {
      this.hamburgerTarget.classList.remove("hidden")
    }

    // Handle overlay for JAP menu
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("opacity-100")
      this.overlayTarget.classList.add("opacity-0", "pointer-events-none")
    }

    // Restore body scroll
    document.body.style.overflow = ""
  }

  closeOnNavigation() {
    // Used by JAP navigation links
    setTimeout(() => {
      this.close()
    }, 100)
  }

  stopPropagation(event) {
    // Prevent closing when clicking inside menu
    event.stopPropagation()
  }
}
